import React from 'react';
import { Text, View, StyleSheet, ActivityIndicator, InteractionManager } from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  uploadFilesAndSaveToServer,
  deleteFile,
  setUploadStatePendingForObject,
  resetUploadStateForObject,
  getFileByTypeAndId,
} from '../../actions';

import { getFileUploadStatusForEditingObject, getFilesForEditingObject } from '../../selector';

import OPComponent from '../../op_component';
import AttachmentsInput from './input';
import AttachmentsInputFiles from './input_files';
import I18n from '../../../../I18n';

import { getFullscreenImageUrl } from '../../attachments/web_fullscreen';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../../actions/statusTypes';
import { THEME } from '../../../../constants/styles';

class AttachmentsUploader extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      newFiles: [],
      removedFiles: [],
    };
  }

  componentDidMount() {
    const { objectType, objectId } = this.props;
    if (!objectType || !objectId) return;

    this.props.actions.resetUploadStateForObject(objectType, objectId);
    this.props.actions.getFileByTypeAndId(objectType, objectId);
  }
  componentWillUnmount() {
    const { objectType, objectId } = this.props;
    if (!objectType || !objectId) return;

    this.props.actions.resetUploadStateForObject(objectType, objectId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      const { objectType, objectId } = this.props;
      this.props.actions.getFileByTypeAndId(objectType, objectId);
    }
    if (this.props.uploadStatus === SUCCESS && prevProps.uploadStatus !== SUCCESS) {
      this.props.onUploadComplete && this.props.onUploadComplete();
    }
    if (this.props.uploadStatus === FAILED && prevProps.uploadStatus !== FAILED) {
      this.props.onUploadFailed && this.props.onUploadFailed(this.props.uploadErrorMessage);
    }

    // TODO: implement this as well for removing files (not supported yet server side)
    const { objectType, objectId } = this.props;
    if (objectId != null) {
      if (this.state.newFiles !== prevState.newFiles) {
        this.props.actions.setUploadStatePendingForObject(objectType, objectId);
      }
    }
  }

  uploadFiles() {
    const { objectType, objectId } = this.props;
    const { newFiles } = this.state;

    if (this.props.uploadStatus === REQUESTING) return;

    if (!objectId) {
      this.props.onUploadFailed?.();
      return;
    }
    if (!newFiles || !newFiles.length) {
      this.props.onUploadComplete?.();
      return;
    }
    // console.info(
    //   'upload_attachments uploadFiles',
    //   objectType,
    //   objectId,
    //   newFiles
    // );

    this.props.onUploadBegin?.();
    this.props.actions.uploadFilesAndSaveToServer(objectType, objectId, newFiles);
  }

  handleAddAttachment = (attachment) => {
    if (this.props.multi) {
      this.setState({ newFiles: this.state.newFiles.concat(attachment) });
    } else {
      this.setState({ newFiles: [attachment] });
    }
  };
  handleRemoveAttachment = (attachment) => {
    let { newFiles, removedFiles } = this.state;
    let i = newFiles.indexOf(attachment);
    if (i >= 0) {
      newFiles.splice(i, 1);
    } else {
      removedFiles.push(attachment);
    }
    this.setState({ newFiles, removedFiles });
  };
  handleDeleteAttachment = (attachment) => {
    this.props.confirmDelete?.(() => {
      this._doDelete(attachment);
    });
  };
  _doDelete = (attachment) => {
    const { objectType, objectId, fileName, fileId } = attachment;
    this.props.actions.deleteFile(objectType, objectId, fileName, fileId);
  };
  handleLinkPress = async (attachment) => {
    const url = await getFullscreenImageUrl(attachment);
    if (url) window.open(url, '_blank');
  };

  render() {
    const files = this.props.files || this.props.savedFiles;
    const InputComp = this.props.links ? AttachmentsInputFiles : AttachmentsInput;

    return (
      <View style={this.props.containerStyle}>
        <InputComp
          attachments={files}
          isThumb={this.props.isThumb}
          existingAttachments={files}
          newAttachments={this.state.newFiles}
          removedAttachments={this.state.removedFiles}
          onAdd={this.handleAddAttachment}
          onRemove={this.handleRemoveAttachment}
          onDelete={this.handleDeleteAttachment}
          onLinkPress={this.handleLinkPress}
        />

        {this.props.uploadStatus === REQUESTING && (
          <View style={styles.uploadIndicatorContainer}>
            <ActivityIndicator animating={true} size="small" color="gray" style={{}} />
            <Text style={THEME.clarifyingNote}> {I18n.t('form.uploadingFiles')}</Text>
          </View>
        )}
        {!!this.props.uploadErrorMessage && (
          <Text style={THEME.errorMessage}>
            {I18n.t('form.uploadFailed')} {this.props.uploadErrorMessage}
          </Text>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  uploadIndicatorContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

function mapStateToProps(state, ownProps) {
  return {
    uploadStatus: getFileUploadStatusForEditingObject(state, ownProps).status,
    uploadErrorMessage: getFileUploadStatusForEditingObject(state, ownProps).errorMessage,
    savedFiles: getFilesForEditingObject(state, ownProps),
    status: state.screens.components.uploads.status,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getFileByTypeAndId,
        uploadFilesAndSaveToServer,
        deleteFile,
        setUploadStatePendingForObject,
        resetUploadStateForObject,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  AttachmentsUploader
);
